// @ts-nocheck
import { paginationStyles } from "@insite/content-library/Widgets/MyLists/MyListsPagination";
import { css } from "styled-components";

Object.assign(paginationStyles, {
    pagination: {
        cssOverrides: {
            pagination: css`
                && {
                    margin-top: ${x => x.theme.design.myAccount.pagination.spacing};
                }
            `,
        },
    },
});
